import {
  ExpandedDetailsSection,
  Flex,
  TestLineageNavButton,
} from '@elementary/common-ui/components';
import SchemaChangesList from '@elementary/common-ui/components/SchemaChangesList';
import { TestResult } from '@elementary/common-ui/types';
import { Stack } from '@mui/material';
import AdditionalActionsButton from './AdditionalActionsButton';
import OpenTestRunsButton from './OpenTestRunsButton';

const SchemaChangesExpandedRow = ({
  rowData,
  showWidgetButtons,
}: {
  rowData: TestResult;
  showWidgetButtons: boolean;
}) => (
  <Stack sx={{ gap: 2 }}>
    {showWidgetButtons && (
      <Flex gap={1} sx={{ alignSelf: 'flex-end' }}>
        <OpenTestRunsButton urlParam={rowData.metadata.elementary_unique_id} />
        {!!rowData.metadata.model_unique_id && (
          <TestLineageNavButton
            modelId={rowData.metadata.model_unique_id}
            testName={rowData.metadata.test_name}
          />
        )}
        <AdditionalActionsButton
          elementaryUniqueId={rowData.metadata.elementary_unique_id}
        />
      </Flex>
    )}
    {!['pass', 'skipped'].includes(rowData.metadata?.latest_run_status) && (
      <SchemaChangesList
        description={rowData.test_results.result_description}
        displayName={rowData.test_results.display_name}
      />
    )}
    <ExpandedDetailsSection data={rowData} />
  </Stack>
);

export default SchemaChangesExpandedRow;
